import { Text } from "@/components/ui/baseUi/text"
import { HighlightingIcon } from "@images/svgIcons/highlightingIcon"
import { InformationAlertIcon } from "@images/svgIcons/informationAlertIcon"
import { word } from "@modules/core/utils/i18n"
import { ProgramBundleType } from "@modules/programBundle/api/programBundleDto"
import { ProgramBundleEntity } from "@modules/programBundle/entities/programBundleEntity"
import { useProgramBundleAthleteSubscription } from "@modules/programBundle/hooks/useProgramBundleSubscription"
import { ProgramSubscriptionStatus } from "@modules/programs/types/programTypes"
import { isInArray } from "@modules/utils/isInArray"

type ProgramBundleTrialCardProps = {
  programBundle: ProgramBundleEntity
} & React.ComponentProps<"div">

export function ProgramBundleTrialCard({ programBundle, ...props }: ProgramBundleTrialCardProps) {
  const { programBundleStripeSubscriptionInfos } = useProgramBundleAthleteSubscription(programBundle)

  return (
    <div className="mb-3 flex flex-col" {...props}>
      {programBundle.trialDuration &&
        (!programBundleStripeSubscriptionInfos ||
          programBundleStripeSubscriptionInfos.subscriptionStatus === ProgramSubscriptionStatus.INACTIVE) &&
        programBundleStripeSubscriptionInfos?.subscriptionStatus !== ProgramSubscriptionStatus.TRIALING &&
        programBundle.isEligibleToTrial && (
          <div className="card relative mb-3 items-start overflow-hidden bg-surface-foreground px-5 pt-3 pb-4">
            <HighlightingIcon className="absolute top-0 left-0 z-0" />

            <div className="z-5 flex flex-row items-center gap-3">
              <Text className="z-2 font-bold" fontStyle="TM">
                {word("programBundle.price.trial.tryBeforeSubscribe")}
              </Text>
              <InformationAlertIcon
                color="currentColor"
                backgroundColor="transparent"
                className="z-2 text-textDefault-heading"
              />
            </div>
            <Text className="z-2" fontStyle="BM">
              {`${word("programBundle.price.trial.description", { count: programBundle.trialDuration })}`}
            </Text>
          </div>
        )}

      {programBundleStripeSubscriptionInfos?.subscriptionStatus ===
        ProgramSubscriptionStatus.TRIAL_PENDING_CANCELLATION && (
        <div className="card relative mb-3 items-start overflow-hidden bg-surface-foreground px-5 pt-3 pb-4">
          <HighlightingIcon className="absolute top-0 left-0 z-0" />

          <div className="flex flex-row items-center gap-3">
            <Text className="z-2" fontStyle="TM">
              {word("programBundle.price.trial.subscriptionCanceled")}
            </Text>
            <InformationAlertIcon
              color="currentColor"
              backgroundColor="transparent"
              className="z-5 text-textDefault-heading"
            />
          </div>
          <Text className="z-2" fontStyle="BM">
            {word("programBundle.price.trial.subscriptionCanceledDescription")}
          </Text>
        </div>
      )}

      {programBundle.type === ProgramBundleType.VIRTUAL &&
        !programBundle.isEligibleToTrial &&
        !isInArray(
          [ProgramSubscriptionStatus.TRIALING, ProgramSubscriptionStatus.TRIAL_PENDING_CANCELLATION],
          programBundleStripeSubscriptionInfos?.subscriptionStatus,
        ) &&
        programBundle.trialDuration !== null && (
          <div className="card relative mb-3 flex flex-col items-start overflow-hidden bg-surface-foreground px-5 pt-3 pb-4">
            <HighlightingIcon className="absolute top-0 left-0 z-0" />

            <div className="flex flex-row items-center gap-3">
              <Text className="z-2" fontStyle="TM">
                {word("programBundle.price.trial.trialPeriodUsedTitle")}
              </Text>
              <InformationAlertIcon
                color="currentColor"
                backgroundColor="transparent"
                className="z-5 text-textDefault-heading"
              />
            </div>
            <Text className="z-2" fontStyle="BM">
              {word("programBundle.price.trial.trialPeriodUsedDescription")}
            </Text>
          </div>
        )}
    </div>
  )
}
